import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { SubmitButtonClickService } from 'src/app/services/submit-button-click.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-trades-modal',
  templateUrl: './trades-modal.component.html',
  styleUrls: ['./trades-modal.component.css']
})
export class TradesModalComponent implements OnInit, OnDestroy {

  @ViewChild('values', { static: false }) valueRef: ElementRef | undefined;

  @Input() tradesData: any;
  @Input() tradesAdd: any;
  @Input() tradesView: any;
  @Input() tradesEdit: any;
  @Input() tabType: any;

  tradesForm: FormGroup;
  type: any;
  formSubmitted: boolean = false;
  existingClicked: boolean = false;
  trades: any = [];
  imageId: any = null;
  isShown: any;
  existingData: any;
  view: boolean = false;
  errorMessage: any = null;

  private _loading: boolean = false;
  private _values: any;
  private _itemClicked: boolean = false;
  private _selectedItems: any = [];
  private _afterClosedSubscription: Subscription;
  private _availableTradesSubscription: Subscription;
  private _saveTradeSubscription: Subscription;
  private _updateSaveTradeSubscription: Subscription;
  
  constructor(
    private _activeModal: NgbActiveModal,
    private _fb: FormBuilder,
    private _service: ServicecallService,
    private _submitButtonClick: SubmitButtonClickService,
    private _submitButtonSuccess: SubmitButtonClickService,
    private _disbaleForm: SubmitButtonClickService,
    private _enableForm: SubmitButtonClickService,
    private _dialog: MatDialog
  ) {
    this.tradesForm = this._fb.group({
      tradeList: [''],
      name: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      type: ['']
    });
  }

  ngOnInit(): void {
    this._checkValidity();
    this._loadConfigurationModalData();
  }
  ngOnDestroy(): void {
    this._afterClosedSubscription?.unsubscribe();
    this._availableTradesSubscription?.unsubscribe();  
    this._saveTradeSubscription?.unsubscribe();  
    this._updateSaveTradeSubscription?.unsubscribe();  
    
  }
  closeModal() {
    if (this.tradesForm.dirty) {
      let dialogRef = this._dialog.open(AlertDialogComponent, {
        data: { msg: Messages.UNSAVED_CHANGES, type: null },
        disableClose: true
      });
      this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._activeModal.close();
        }
      });
    }
    else {
      this._activeModal.close();
    }
  }

  onChangeAdd(item: any) {
    this.tradesForm.reset();
    this._submitButtonSuccess.setSubmitButtonSuccess('success');
    if (item.value === 'new') {
      this._itemClicked = true;
      this.existingClicked = false;
      if (!this.existingClicked) {
        this.tradesForm.controls['name'].enable();
        this._enableForm.setEnableFormSuccess('clicked');
      }
    } else {
      this._itemClicked = false;
      this.existingClicked = true;
      if (this.existingClicked) {
        this.tradesForm.controls['name'].disable();
        this._disbaleForm.setDisableFormSuccess('clicked');
      }
    }
  }

  getValues(event: {
    isUserInput: any;
    source: { value: any; selected: any };
  }) {
    if (event.isUserInput) {
      if (event.source.selected === true) {
        this._selectedItems = event.source.value;
        this._loadTradeData();
      }
    }
  }
  
  onSubmit() {
    this.formSubmitted = true;
    if (this.tradesForm.invalid) {
      return;
    }
    if (this.tradesAdd) {
      this._saveTrades();
    } else if (this.tradesEdit) {
      this._updateTrades();
    }
  }
  get formValues() {
    return this.tradesForm.controls;
  }

  private _checkValidity() {
    if (this.tabType === 'tenant') {
      this.isShown = 'tenant';
      this._availableTrades();
    } else if (this.tabType === 'global') {
      this.isShown = 'global';
    }
  }

  
  private _availableTrades() {
    this.trades = [];
    this._availableTradesSubscription = this._service.availableTrades().subscribe((result: any) => {
      if (result['status']) {
        if (result['response'].length > 0) {
          this.trades = result['response'];
        }
      }
    });
  }


  private _loadTradeData() {
    if (this._selectedItems) {
      let arr = this.trades.find((x: any) => x.tradeName === this._selectedItems);
      this.existingData = arr;
      if (arr) {
        this.tradesForm.patchValue({
          name: {
            image: arr.imageId,
            name: arr.tradeName,
            description: arr.description
          }
        });
        this.formValues['tradeList'].patchValue(this._selectedItems);
        this.imageId = arr.imageId;
      }
    }
  }

  private _loadConfigurationModalData() {
    this.type = this._service.getConfiguration('typ') ? this._service.getConfiguration('typ').scope : [];
    if (this.tradesData) {
      if (this.tradesView) {
        this.view = true;
        this.tradesForm.disable();
        this._disbaleForm.setDisableFormSuccess('clicked');
      }
    }
    this._patchValues();
  }

  //   this._service.configurationsInfo(this.attributes).subscribe((results: any) => {
  //     this.loading = false;
  //     let configList: any = results['response'];
  //     configList.forEach((element: any) => {
  //       if (element['attribute'] === 'typ') {
  //         this.type = element['values'].scope;
  //       }
  //     })
  //     if (this.tradesData) {
  //       if (this.tradesView) {
  //         this.view = true;
  //         this.tradesForm.disable();
  //         this.disbaleForm.setDisableFormSuccess('clicked');
  //       }
  //     }
  //     this.patchValues();
  //   });
  // }

  private _patchValues() {
    if (this.tradesAdd) {
      this.tradesForm.patchValue({
        imageId: this.tradesForm.value.name.image,
        tradeName: this.tradesForm.value.name.name,
        description: this.tradesForm.value.name.description,
        type: 'global'
      });
    } else {
      this.tradesForm.patchValue({
        name: {
          image: this.tradesData.imageId,
          name: this.tradesData.tradeName,
          description: this.tradesData.description
        },
        type: this.tradesData.type
      });
      this.imageId = this.tradesData.imageId;
    }
  }

  private _saveTrades() {
    this.errorMessage = null;
    if (this.tradesForm.invalid && !this.existingClicked) {
      return;
    }
    this._submitButtonClick.setSubmitButtonClick('clicked');
    if (this.tradesForm.controls['name']['value'].image) {
      this._loading = true;
      let postData;
      let data = this.tradesForm.getRawValue();
      data.group = this.tabType === 'global' ? 'system' : 'userdefined';
      data.metadata = {
        'createdBy': localStorage.getItem('userId') ?
          localStorage.getItem('userId') : null
      };

      switch (this.tabType) {
        case 'site': data.type = 'site'
          break;
        case 'tenant': data.type = 'tenant'
          break;
        case 'global': data.type = data.type
          break;
        default:
          break;
      }
      data.tradeName = this.tradesForm.controls['name']['value'].name;
      data.imageId = this.tradesForm.controls['name']['value'].image;
      data.description = this.tradesForm.controls['name']['value'].description;

      postData = { set: data };

      this._saveTradeSubscription = this._service.saveTrade(postData).subscribe((result: any) => {
        if (result['status'] && result['response']) {
          if (result['status']) {
            this._service.toasterService({ type: 'success', msg: result['response']['message'] });
            this._submitButtonSuccess.setSubmitButtonSuccess('success');
            this._loading = false;
            this._activeModal.close(true);
          } else {
            this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
            // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
            this._loading = false;
          }
        } else {
          if (result['response']) {
            this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
            // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
            this._loading = false;
          }
        }
      });
    }
  }

  private _updateTrades() {
    this.errorMessage = null;
    if (this.tradesForm.invalid && !this.existingClicked) {
      return;
    }
    this._submitButtonClick.setSubmitButtonClick('clicked');
    if (this.tradesForm.value.name.image) {
      this._loading = true;
      let postData;

      if (this.tradesData.tradeName === this.tradesForm.value.name.name) {
        this.tradesForm.value.name.name = null;
      } else if (this.tradesData.description === this.tradesForm.value.name.description) {
        this.tradesForm.value.name.description = null;
      }
      const request = {
        tradeName: this.tradesForm.value.name.name,
        description: this.tradesForm.value.name.description,
        imageId: this.tradesForm.value.name.image ? this.tradesForm.value.name.image : null,
        group: this.tradesForm.value.group
      }
      postData = { tradeId: this.tradesData['_id'], set: request };

      this._updateSaveTradeSubscription = this._service.saveTrade(postData).subscribe((result: any) => {
        if (result['status'] && result['response']) {
          if (result['status']) {
            this._service.toasterService({ type: 'success', msg: result['response']['message'] });
            this._submitButtonSuccess.setSubmitButtonSuccess('success');
            this._loading = false;
            this._activeModal.close(true);
          } else {
            this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
            // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
            this._loading = false;
          }
        } else {
          if (result['response']) {
            this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
            // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
            this._loading = false;
          }
        }
      });
    }
  }
}
